import AContainer from '../../library/ExtendedObjects/AContainer.js';

export default class PortalImport extends AContainer
{
    constructor(scene)
    {
        super(scene);
    
        this.createPortal();
        this.rotatePortal();
    }

    createPortal()
    {
        this.portal = this.create(0, -30, "WordPortalOrangeVortex");
        this.portalFrame = this.create(0, 0, "WordPortalOrangeFrame");
    }

    rotatePortal()
    {
        this.scene.addTween(this.portal, 10000, {angle:-360, repeat:-1}, Phaser.Math.Easing.None);
    }

    flicker()
    {
        let randHold = Phaser.Math.Between(0, 500);
        let randRepeat = Phaser.Math.Between(2, 4);

        this.particleSparks();

        this.scene.addTween(this.portal, 50, {alpha: 1, repeat:4, onRepeat:()=>{this.particleSparks()}, yoyo:true, hold:randHold}, Phaser.Math.Easing.Quadratic.InOut);
    }

    particleSparks()
    {
        let randAmount = Phaser.Math.Between(50, 100);

        let emitter = this.scene.add.particles(this.scene.particleAtlas, "yellowBurst").createEmitter({
            x: this.x + this.portal.x,
            y: this.y + this.portal.y,
            speed: { min: -400, max: 400 },
            scale: {start: Phaser.Math.FloatBetween(.5, 1), end: 0 },
            blendMode: 'SCREEN',//{'SCREEN' || "ADD" || "MULTIPLY"},
            lifespan: Phaser.Math.Between(400, 1000),
            gravityY:300,
            alpha: { min: 0, max: 1 },
            quantity: randAmount,
            maxParticles: randAmount,
        });
    }

    tweenInPortal()
    {
        this.scene.addTween(this, 2000, {y:650}, Phaser.Math.Easing.Quadratic.Out);
    }

    tweenOutPortal()
    {
        this.scene.addTween(this, 1000, {y:950}, Phaser.Math.Easing.Quadratic.In,
            ()=>{this.cleanUp();});
    }

    cleanUp()
    {
        this.scene.killTween(this.portal);
        this.portal.destroy();
        this.portalFrame.destroy();
    }
}